import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import { selectResellerConfig } from "../Store/configSlice";
import { selectUserId } from "../Store/adminSlice";

const RestrictReadOnly = ({ children }) => {
  const resellerConfig = useSelector(selectResellerConfig);
  const userId = useSelector(selectUserId);

  if ((resellerConfig && resellerConfig.readonly) || userId) {
    return <Fragment />;
  }

  // Clone the child component and add readOnly prop
  return children;
};

export default RestrictReadOnly;
